import {
  Burger,
  Badge,
  Text,
  Group,
  NumberFormatter,
  Loader,
  Tooltip,
} from "@mantine/core";
import { useStore } from "./store";
import { Link, useLocation } from "wouter";
import { useEffect } from "react";
import { IconCoins } from "@tabler/icons-react";

function colorForCredits(credits) {
  if (credits > 9 * 1_000_000) return "teal";
  if (credits > 4 * 1_000_000) return "shuttle-amber";
  return "red";
}

export default function AppHeader({ opened, toggle }) {
  const { profile, profileLoading, fetchProfile } = useStore();
  const [location] = useLocation();

  // Update profile when location changes
  useEffect(() => {
    fetchProfile();
  }, [location, fetchProfile]);

  return (
    <Group h="100%" px="sm" justify="space-between">
      <Group gap="xs">
        <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
        <img src="/logo.png" alt="PromptShuttle" width="24" height="24" />
        <Text fw={700} size="sm" visibleFrom="xs">PromptShuttle</Text>
      </Group>

      {profile && (
        <Group>
          {profile.tenantName && (
            <Badge radius="xs" color="gray">
              {profile.tenantName}
            </Badge>
          )}
          <Tooltip
            label={
              profile.credits < 1_000_000
                ? "You're low on credits. Click to top up."
                : "View your profile"
            }
          >
            <Badge
              style={{ cursor: "pointer" }}
              color={colorForCredits(profile.credits)}
              leftSection={
                profileLoading ? (
                  <Loader color="white" size={14} />
                ) : (
                  <IconCoins size={14} />
                )
              }
              component={Link}
              to="/tenant/profile"
            >
              Credits:{" "}
              <NumberFormatter
                value={profile.credits / 1000000}
                decimalScale={2}
                title={profile.credits}
                thousandSeparator
                suffix="$"
              />
            </Badge>
          </Tooltip>
        </Group>
      )}
    </Group>
  );
}
